import { useState } from 'react';
import { Checkbox, Button, Icon, Menu, MenuItem, ThemeProvider } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import MeasurementService from '../service/MeasurementService';
import MergeMeasurementsDialog from './MergeMeasurementsDialog';

function MergeMeasurementsButton() {
    const mainTheme = useSelector(selectMainTheme);
    const [anchorEl, setAnchorEl] = useState(null);
    const [items, setItems] = useState(null);
    const [selected, setSelected] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    if (items == null) {
        MeasurementService.getListSelection().then(resp => { setItems(resp); });
        return <></>;
    }

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (item) => {
        let _selected = [...selected];

        if (_selected.indexOf(item.id) > -1) {
            _selected.splice(_selected.indexOf(item.id), 1);
        } else {
            _selected.push(item.id)
        }

        setSelected(_selected);
    };

    return (
        <>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} className="whitespace-nowrap mx-8" variant="contained" color="secondary" startIcon={<Icon className="hidden sm:flex">call_merge</Icon>}>
                Merge Measurements
            </Button>

            <ThemeProvider theme={mainTheme}>

                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}>

                    {items.map((item, index) => (<MenuItem key={index} role="button" onClick={() => handleChange(item)}>
                        <Checkbox className='pl-0' checked={selected.indexOf(item.id) > -1} />
                        {item.name}
                    </MenuItem>))}

                    <div className='w-full px-12 pb-4 pt-12 border-t'>
                        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={() => setOpenDialog(true)} className="w-full whitespace-nowrap" variant="contained" color="primary" /*size='small'*/ startIcon={<Icon className="hidden sm:flex">call_merge</Icon>}>
                            Merge
                        </Button>
                    </div>

                </Menu>

                {openDialog && (
                    <MergeMeasurementsDialog
                        subjectMeasurements={selected}
                        onCancel={() => setOpenDialog(false)}
                        onSave={result => { setOpenDialog(false); }}
                    />
                )}

            </ThemeProvider>



        </>
    );
}

export default MergeMeasurementsButton;